/* eslint-disable react/jsx-no-target-blank */
import {useState, useEffect} from 'react'

import {useIntl} from 'react-intl'

import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {getMenus} from '../../../../app/modules/apps/pages/menus/core/_requests'
import {Menu} from '../../../../app/modules/apps/pages/menus/core/_models'
import {useAuth} from '../../../../app/modules/auth'
import {getAccessGroupById} from '../../../../app/modules/apps/pages/accessgroups/core/_requests'
import {AccessGroup} from '../../../../app/modules/apps/pages/accessgroups/core/_models'

export function AsideMenuMain() {
  const [menus, setMenus] = useState<Menu[]>([])
  const [userAccessGroup, setUserAccessGroup] = useState<AccessGroup>({})
  const {currentUser} = useAuth()
  const intl = useIntl()

  useEffect(() => {
    async function loadMenus() {
      const menus = await getMenus('', 1, Number.MAX_SAFE_INTEGER)
      setMenus(menus)

      const accessGroup = await getAccessGroupById(currentUser?.idGrupoDeAcesso?.id)

      setUserAccessGroup(accessGroup)

      localStorage.setItem('protocolos_accessGroup', JSON.stringify(accessGroup))
    }

    loadMenus()
  }, [])

  return (
    <>
      {menus
        .filter((menu) => userAccessGroup?.menu?.find((m) => m.id === menu.id))
        .sort((a, b) => (a.ordem || 1) - (b.ordem || 1))
        .map((menu) => (
          <>
            {
              //checar se o currentUser tem permissao de visualizar o menu
              userAccessGroup?.menu
                ?.find((m) => m.nome === menu.nome)
                ?.acoes?.find((acao) => acao.nome === 'visualizar') && (
                <AsideMenuItem to={menu.rota || ''} icon='archive' title={menu.nome || ''} />
              )
            }
          </>
        ))}

      {/* <AsideMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
      />
      <AsideMenuItem to='/apps/protocols' icon='archive' title='Protocolos' />
      <AsideMenuItem to='/apps/proposals' icon='file' title='Propostas' /> */}
      {/* <AsideMenuItem to='/apps/document-requests' icon='shop' title='Solicitação de documentos' /> */}
      {/* <AsideMenuItem to='/apps/receptions' icon='shop' title='Recepção de malotes' /> */}
      {/* <AsideMenuItem to='/apps/reports' icon='some-files' title='Relatórios' /> */}

      {/* <AsideMenuItemWithSub to='#' title='Configurações' icon='gear'>
        <AsideMenuItem to='/apps/document-types' title='Tipos de documento' />
        <AsideMenuItem to='/apps/protocol-types' title='Tipos de protocolo' />
        <AsideMenuItem to='/apps/business-groups' title='Grupos empresariais' />
        <AsideMenuItem to='/apps/companies' title='Empresas' />
        <AsideMenuItem to='/apps/cost-center' title='Área/Centro de custo' />
        <AsideMenuItem to='/apps/departaments' title='Sub área/Departamentos' />
      </AsideMenuItemWithSub> */}

      {/* <AsideMenuItemWithSub to='#' title='Controle de acesso' icon='user'>
        <AsideMenuItem to='/apps/users' title='Usuarios' />
        <AsideMenuItem to='/apps/access-groups' title='Grupos de acesso' />
        <AsideMenuItem to='/apps/menus' title='Menus' />
      </AsideMenuItemWithSub> */}

      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div> */}

      {/* <AsideMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
        <AsideMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
        <AsideMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
        <AsideMenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
        <AsideMenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
        <AsideMenuItem
          to='/crafted/pages/profile/connections'
          title='Connections'
          hasBullet={true}
        />
      </AsideMenuItemWithSub> */}

      {/* <AsideMenuItemWithSub to='/crafted/pages' title='Pages' icon='gift'>
        <AsideMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <AsideMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
          <AsideMenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
          <AsideMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <AsideMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <AsideMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </AsideMenuItemWithSub>
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to='/crafted/accounts' title='Accounts' icon='profile-circle'>
        <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <AsideMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to='/error' title='Errors' icon='cross-circle'>
        <AsideMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <AsideMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub to='/crafted/widgets' title='Widgets' icon='element-plus'>
        <AsideMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <AsideMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </AsideMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <AsideMenuItemWithSub to='/apps/chat' title='Chat' icon='message-text-2'>
        <AsideMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <AsideMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </AsideMenuItemWithSub> */}
      {/* <AsideMenuItem to='/apps/user-management/users' icon='shield-tick' title='User management' />
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div> */}
      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTIcon iconName='document' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}
